import * as React from 'react';

import { useAtomValue } from 'jotai';

import { $headerRect } from '~/modules/trade/_state/materialsInterface.state';
import { calculateModalStyle, FALLBACK_MODAL_STYLE } from '~/shared/hooks';

export const useDialogModalStyle = (): React.CSSProperties => {
  const headerRect = useAtomValue($headerRect);

  return React.useMemo<React.CSSProperties>(() => {
    if (headerRect?.width && headerRect?.height) {
      return calculateModalStyle(headerRect);
    }
    return FALLBACK_MODAL_STYLE;
  }, [headerRect]);
};
